import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor() { }

  isNumber(n: string) {
    let re = /^(\$)?([0-9]+)?(\.)?([0-9]+)?$/;
    return (n != null && n.length > 0 && !re.test(n) ? false : true); 
  }

  isPercentage(n: string) {
    if(this.isNumber(n)) {
      let f = parseFloat(n);
      return (f >= 0 && f <= 100);
    } else {
      return false;
    }
  }

  validatePercentage(n: any): boolean {
    if(n != null) {
      return this.isPercentage(String(n));
    }

    return true;
  }
  
  isCurrency(n: string) {
    if(this.isNumber(n)) {
      let f = parseFloat(n);
      return (f >= 0);
    } else {
      return false;
    }
  }

  validateCurrency(n: any): boolean {
    if(n != null) {
      return this.isCurrency(String(n));
    }

    return true;
  }

  isDate(dateString: string) {
    // First check for the pattern
    if(!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
        return false;
    }

    // Parse the date parts to integers
    let parts = dateString.split("/");
    let day = parseInt(parts[1], 10);
    let month = parseInt(parts[0], 10);
    let year = parseInt(parts[2], 10);

    // Check the ranges of month and year
    if(year < 1000 || year > 3000 || month == 0 || month > 12) {
        return false;
    }

    let monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

    // Adjust for leap years
    if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) {
        monthLength[1] = 29;
    }
    
    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
  }
}
